import './bootstrap'
import '@/assets/styles/main.scss'
import '@vueform/multiselect/themes/default.css'
import 'gitart-vue-dialog/dist/style.css'

import { createApp, h } from 'vue'
import { createPinia } from 'pinia'
import { createInertiaApp } from '@inertiajs/vue3'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import { ZiggyVue } from '../../vendor/tightenco/ziggy'
import i18n from './i18n'
import { modal } from 'momentum-modal'
import { GDialog } from 'gitart-vue-dialog'
import VueSidePanel from 'vue3-side-panel'
import Toaster from '@meforma/vue-toaster'
import FloatingVue from 'floating-vue'
import 'vue3-side-panel/dist/vue3-side-panel.css'
import 'floating-vue/dist/style.css'

const appName = import.meta.env.VITE_APP_NAME || 'Laravel'

createInertiaApp({
    title: () => `${appName}`,
    resolve: (name) =>
        resolvePageComponent(`./pages/${name}.vue`, import.meta.glob('./pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const pinia = createPinia()

        return createApp({ render: () => h(App, props) })
            .use(modal, {
                resolve: (name) =>
                    resolvePageComponent(
                        `./modals/${name}.vue`,
                        import.meta.glob('./modals/**/*.vue')
                    )
            })
            .component('GDialog', GDialog)
            .use(VueSidePanel)
            .use(Toaster, {
                position: 'bottom'
            })
            .use(FloatingVue)
            .use(plugin)
            .use(i18n)
            .use(ZiggyVue)
            .use(pinia)
            .mount(el)
    },
    progress: {
        color: '#D97706'
    }
})
